import React from "react";
import Photo from "../../Assets/Img/Mansura.jpeg";
import Icon from "../../Assets/Img/Icon.png";
import Slider from "react-slick";
import ReactHtmlParser from "react-html-parser";

class Motamot extends React.Component {
  constructor() {
    super();
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);

    this.state = {
      Next: function () {
        Slider.slickNext();
      },
    };
  }
  next() {
    this.slider.slickNext();
    this.slider2.slickNext();
  }
  previous() {
    this.slider.slickPrev();
    this.slider2.slickPrev();
  }

  render() {
    let settings = {
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
    };

    let reviews = [
      {
        name: "মানসুবা তাবাসসুম হক বিয়াস",
        designation: "শিক্ষক, ঢাকা বিশ্ববিদ্যালয়",
        comment:
          "বেশ কয়েক বছর ধরেই রাজশাহীর আম থেকে আম কিনে খাচ্ছি। প্রতিটা আমের পেছনে রয়েছে কিছু সৎ, পরিশ্রমী ও মেধাবী মানুষের শ্রম। এদের মাধ্যমেই ল্যাংড়া, ফজলি, হিমসাগর ছাড়াও চিনেছি তোতাপুরী, সুর্যপুরী, গুটি আমসহ আরও কত কি! <br/> <br/> বেঁচে থাকুক রাজশাহীর আম। <br/> শুভ কামনা।",
      },
      {
        name: "Dr. Md. Russeel Chowdhury",
        designation: "Best Online Mango Supplier",
        comment:
          "Extremely good Customer Care Services. A shop that cares relations more than Business",
      }
    ];
    return (
      <>
        <div id="Motamot" className="pt-4 pb-5">
          <div className="container pb-0 pb-sm-3">
            <h4 className="text-start m-0  MotamotTitle">কাস্টমারদের মতামত</h4>
            <div className="row align-items-center">
              <div className="col-12 col-sm-6 col-lg-6 col-md-6">
                <Slider ref={(c) => (this.slider = c)} {...settings}>
                  {reviews.map((review, index) => (
                    <SingleReview key={index} review={review} />
                  ))}
                </Slider>
              </div>
              <div className="col-12 col-sm-1 col-lg-1 col-md-1"></div>
              <div className="col-12 d-none d-sm-block col-lg-4 col-sm-5 col-md-4">
                <div className="card position-relative">
                  <img className="img-fluid" src={Photo} />
                  <div
                    style={{
                      top: "40px",
                      left: "-100px",
                      borderRadius: "15px",
                    }}
                    className="MotamotCount card-body bg-white position-absolute"
                  >
                    <div className="d-flex align-items-start">
                      <i
                        style={{ marginRight: 10 }}
                        className="fa-regular bg-success text-white rounded-circle  p-2 fa-star"
                      ></i>
                      <div>
                        <h5 className="m-0 text-start">২৩৪৪৪</h5>
                        <p className="text-secondary m-0">কাস্টমারদের মতামত</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default Motamot;

function SingleReview({ review }) {
  return (
    <div className="MotamotItem d-flex justify-content-center">
      <div style={{ borderRadius: 15 }} className="card w-75">
        <div className="card-body p-lg-5 p-md-3 ">
          <div className="icon d-flex justify-content-center">
            <img className="img-fluid" src={Icon} />
          </div>
          <div className="text mt-3">
            <p className="lh-lg text-secondary">
              { ReactHtmlParser(review.comment)}
            </p>
          </div>
          <div className="WhoAre">
            <p>
              {review.name} <br />{" "}
              <span className="text-secondary">{review.designation}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
